var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{attrs:{"readonly":_vm.readonly}},[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"mb-2"},[_c('v-card-title',[_vm._v(" Оценка экономических последствий ")]),_c('v-card-text',[_c('EconomicTable',{attrs:{"value":_vm.data,"readonly":_vm.readonly},on:{"change":_vm.doChangeEconomic,"blur":_vm.doBlur}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }